import { Injectable, inject } from '@angular/core';

import { Fixture } from '@cds/betting-offer';
import { OnAppInit, WINDOW } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';

import { ExternalBetslipActions } from '../../core/external-betslip-actions';

@Injectable({ providedIn: 'root' })
export class WebBridgeService implements OnAppInit {
    private store = inject(Store);

    onAppInit(): void {
        this._window['webApp'] = {
            addPick: this.addPick,

            removePick: this.removePick,
        };
    }

    private addPick = (fixture: Fixture, option: number) => this.store.dispatch(ExternalBetslipActions.addWebAppPick({ fixture, option }));

    private removePick = (fixture: Fixture, option: number) => this.store.dispatch(ExternalBetslipActions.removeWebAppPick({ fixture, option }));
    private readonly _window = inject(WINDOW);
}
